/* Graffix Plug home page — announcement rotation + gallery filters */
(function () {
  if (window.__gpHomeLoaded) return;
  window.__gpHomeLoaded = true;

  function initAnnouncement(root) {
    var msgs = root.querySelectorAll('.gp-ann__msg');
    if (msgs.length < 2) return;
    var i = 0;
    var ms = (parseInt(root.getAttribute('data-speed'), 10) || 5) * 1000;
    var timer = setInterval(function () {
      if (!document.body.contains(root)) { clearInterval(timer); return; }
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, ms);
  }

  function initGallery(root) {
    var pills = root.querySelectorAll('[data-gp-filter]');
    var items = root.querySelectorAll('[data-gp-tags]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var f = pill.getAttribute('data-gp-filter');
        pills.forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        items.forEach(function (it) {
          var tags = ' ' + (it.getAttribute('data-gp-tags') || '') + ' ';
          it.hidden = f !== 'all' && tags.indexOf(' ' + f + ' ') === -1;
        });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.gp-ann:not([data-gp-init])').forEach(function (el) {
      el.setAttribute('data-gp-init', '');
      initAnnouncement(el);
    });
    (scope || document).querySelectorAll('.gp-gal:not([data-gp-init])').forEach(function (el) {
      el.setAttribute('data-gp-init', '');
      initGallery(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
